import { periodAPI } from 'api/period';
import { FindAllPeriodDto } from 'dto/period';
import { useInfiniteQuery } from 'react-query';
import { defaultCompactPageSize, defaultPageIndex } from 'utils/constants';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  filters: FindAllPeriodDto;
};

export function useFindAllPeriodCompact(props: PropsType) {
  const infiniteQuery = useInfiniteQuery({
    queryKey: [QUERY_KEY.FIND_ALL_PERIOD_COMPACT, props.filters],
    queryFn: ({ pageParam = defaultPageIndex }) =>
      periodAPI.findAllCompact({
        ...props.filters,
        pageIndex: pageParam,
        pageSize: defaultCompactPageSize,
      }),
    getNextPageParam: (lastPage, allPages) => allPages.length + 1,
    cacheTime: 0,
  });

  return {
    infiniteQuery: infiniteQuery,
    count: infiniteQuery.data?.pages[0].count ?? 0,
    rows: infiniteQuery.data?.pages.flatMap((page) => page.rows) ?? [],
    loading:
      infiniteQuery.isLoading ||
      infiniteQuery.isFetching ||
      infiniteQuery.isRefetching,
  };
}
